import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import ReportTableHeader from "./ReportTableHeader";

function GlobalReportTable(props) {
  const data = props.data;
  const consolidatedList = data.consolidateList;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        {data && consolidatedList && consolidatedList.length > 0 ? (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col">{Constants.AP_Code}</th>
                <th scope="col" className="text-center">
                  {Constants.Client_Code}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Client_Name}
                </th>
                <th scope="col" className="text-center">
                  {Constants.MTF_Ledger}
                </th>
                <th scope="col" className="text-center">
                  Normal Ledger
                </th>
                <th scope="col" className="text-center">
                  Net ledger Balance
                </th>
                <th scope="col" className="text-center">
                  Holding Valuation
                </th>
                <th scope="col" className="text-center">
                  MTF Holding
                </th>
                <th scope="col" className="text-center">
                  {Constants.Morning_Limit_Report}
                </th>
                <th scope="col" className="text-center">
                  Trading Status
                </th>
                <th scope="col" className="text-center">
                  DDPI/POA Status
                </th>
              </tr>
            </thead>
            <tbody>
              {consolidatedList.map((item, index) => (
                <tr key={index}>
                  <td>{item.apCode || "-"}</td>
                  <td className="text-center">{item.clientCode || "-"}</td>
                  <td className="text-center">{item.clientName || "-"}</td>
                  <td className="text-center">{item.mtfLedger ?? "-"}</td>
                  <td className="text-center">{item.normalledger ?? "-"}</td>
                  <td className="text-center">
                    {item.netLedgerBalance ?? "-"}
                  </td>
                  <td className="text-center">{item.holdingValue ?? "-"}</td>
                  <td className="text-center">{item.mftHolding ?? "-"}</td>
                  <td className="text-center">{item.morningLimitReport ?? "-"}</td>
                  <td className="text-center">{item.tradingStatus || "-"}</td>
                  <td className="text-center">{item.ddpiPOAStatus || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="report-error-message">
            {Constants.Global_Report_doesnt_exist}
          </div>
        )}
      </div>
    </>
  );
}

export default GlobalReportTable;
